import { RsiRow } from './rsiConfig';

// RSI is used for column-mapping only. 
// All row and global validation is handled post-import via validateScheduleRows().
// These hooks are intentionally empty.

export const rsiRowHook = (row: RsiRow, addError: (field: string, error: string) => void): RsiRow => {
  return row;
};

export const rsiTableHook = (rows: RsiRow[], addError: (rowIndex: number, field: string, error: string) => void): RsiRow[] => {
  return rows;
};
